import I18n from "@/i18n-js/instance";
import { useCourseCustomLabels } from "@/react/components/Spaces/CourseSpace/Shared/useCourseCustomLabels";
import { ProgressBar } from "@circle-react/components/Courses/ProgressBar";
import {
  useCurrentSpaceContext,
  useSpaceResource,
} from "@circle-react/contexts";
import { Typography } from "@circle-react-uikit/Typography";

const getProgress = ({ completedLessons, totalLessons }) => {
  if (totalLessons === 0) {
    return 0;
  }
  return Math.round((completedLessons / totalLessons) * 100);
};

export const Progress = () => {
  const { data: currentSpace } = useCurrentSpaceContext();
  const { data: spaceResource, isLoading } = useSpaceResource({
    spaceId: currentSpace?.id,
  });

  const { translatedLabels } = useCourseCustomLabels();

  if (!spaceResource || isLoading) {
    return null;
  }

  const totalLessons = spaceResource.course_sections.reduce(
    (total, section) => total + section.lessons.length,
    0,
  );

  const completedLessons = spaceResource.course_sections.reduce(
    (total, section) =>
      total + section.lessons.filter(lesson => lesson.completed).length,
    0,
  );

  const progress = getProgress({ completedLessons, totalLessons });

  if (progress === 100) {
    return null;
  }

  return (
    <div className="mt-10 flex w-full flex-col space-y-4">
      <Typography.TitleSm as="h3" weight="semibold">
        {I18n.t("courses.progress")}
      </Typography.TitleSm>
      <div
        className="border-primary space-y-5 rounded-lg border px-6 py-5"
        data-testid="course-progress"
      >
        <div className="flex w-full items-center">
          <div className="flex-1">
            <Typography.LabelMd>
              {I18n.t("courses.completed_count", {
                completed: completedLessons,
                total: totalLessons,
                lessonSingular: (totalLessons === 1
                  ? translatedLabels.lesson.singular
                  : translatedLabels.lesson.plural
                ).toLowerCase(),
              })}
            </Typography.LabelMd>
          </div>
          <Typography.LabelMd weight="semibold">{progress}%</Typography.LabelMd>
        </div>
        <ProgressBar size="md" hideLabel progress={progress} />
      </div>
    </div>
  );
};
